import {
  OrderModificationRequestStatusSchema,
  type OrderModificationRequestStatus as GeneratedOrderModificationRequestStatus
} from '~/services/api/generated'

// Mirrors backend App\Enums\Order\OrderModificationRequestStatus

export type OrderModificationRequestStatus = GeneratedOrderModificationRequestStatus

export const OrderModificationRequestStatus = {
  PENDING_PARTNER: OrderModificationRequestStatusSchema.enum.pending_partner,
  APPLIED: OrderModificationRequestStatusSchema.enum.applied,
  REJECTED: OrderModificationRequestStatusSchema.enum.rejected,
  CANCELLED: OrderModificationRequestStatusSchema.enum.cancelled
} satisfies Record<string, GeneratedOrderModificationRequestStatus>

export const OrderModificationRequestStatusValues: readonly GeneratedOrderModificationRequestStatus[] =
  [
    OrderModificationRequestStatusSchema.enum.pending_partner,
    OrderModificationRequestStatusSchema.enum.applied,
    OrderModificationRequestStatusSchema.enum.rejected,
    OrderModificationRequestStatusSchema.enum.cancelled
  ]
